import { Box, VStack } from "@chakra-ui/react"
import Link from "@pathwright/ui/src/components/link/Link"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import Tooltip from "@pathwright/ux/src/components/tooltip/Tooltip"
import { forwardRef } from "react"
import { getGroupSubscriptionLinkProps } from "../../utils"

const MentorGroupSeats = forwardRef(function MentorGroupSeats(
  { mentorGroup, children, ...props },
  ref
) {
  const { t } = useTranslate()

  return mentorGroup?.seat_limit ? (
    <Tooltip
      title={
        mentorGroup.type === 15 ? (
          <VStack gap={0} alignItems="flex-start">
            <span>
              {t("share_card.meta.group.seats.subscription_seats_remaining", {
                count: mentorGroup.seats_available
              })}
            </span>

            <Link
              variant="underline"
              color="inherit"
              {...getGroupSubscriptionLinkProps(mentorGroup?.groupSubscription)}
            >
              {t(
                "share_card.meta.group.seats.subscription_seats_purchase_more"
              )}
            </Link>
          </VStack>
        ) : (
          <VStack alignItems="flex-start">
            <span>
              {t("share_card.meta.group.seats.seats_remaining", {
                count: mentorGroup.seats_available
              })}
            </span>
          </VStack>
        )
      }
    >
      <Link
        ref={ref}
        {...getGroupSubscriptionLinkProps(mentorGroup?.groupSubscription)}
        variant="plain"
        colorPalette="gray"
        size="sm"
        {...props}
      >
        {children || <span>{t("mentor_group.seats", mentorGroup)}</span>}
        {mentorGroup.seats_available < 0 && (
          <Box
            pos="absolute"
            right="-.1em"
            top="-.1em"
            w=".6em"
            h=".6em"
            bg="red"
            borderRadius="50%"
          />
        )}
      </Link>
    </Tooltip>
  ) : null
})

export default MentorGroupSeats
